import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TestimonialService {

  constructor(
    private _http: HttpClient
  ) { }

  getTestimonials(limit:number):Observable<any>{
    return this._http.get(environment.apiEndpoint+'/api/testimonials/'+limit).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }
}
